// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ov-page {
  min-height: 100%;
}

.license-overview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

.ov-page--embedded {
  min-height: 0;
}

.ov-page--embedded .ov-stats {
  margin-bottom: 0;
}

.ov-stats--loading .ov-stat--skeleton {
  min-height: 88px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: ov-shimmer 1.2s infinite;
}

@keyframes ov-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.ov-page-error-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #991b1b;
  font-size: 14px;
}

.ov-page-error-inline p {
  margin: 0;
  flex: 1 1;
}


.ov-stats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.ov-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ov-stat:not(.ov-stat--static) {
  cursor: pointer;
}

.ov-stat:not(.ov-stat--static):hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.ov-stat--active {
  border-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);
}

.ov-stat-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ov-stat-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ov-stat-icon--blue { background: #eff6ff; color: #2563eb; }
.ov-stat-icon--green { background: #ecfdf5; color: #059669; }
.ov-stat-icon--amber { background: #fffbeb; color: #d97706; }
.ov-stat-icon--red { background: #fef2f2; color: #dc2626; }
.ov-stat-icon--slate { background: #f1f5f9; color: #64748b; }

.ov-stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.ov-stat-label {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ov-stat-hint {
  font-size: 14px;
  color: #cbd5e1;
  margin-top: -2px;
}

.ov-stat--clickable .ov-stat-hint {
  color: #94a3b8;
}

/* Expiring panel */
.ov-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  animation: ov-slide 0.18s ease-out;
}

@keyframes ov-slide {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.ov-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}

.ov-panel-title {
  font-size: 15px;
  font-weight: 600;
  color: #334155;
  margin: 0;
}

.ov-panel-sub {
  font-size: 13px;
  color: #94a3b8;
  margin: 2px 0 0;
}

.ov-panel-close {
  width: 28px;
  height: 28px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ov-panel-body {
  position: relative;
  min-height: 60px;
}

.ov-panel-loading {
  padding: 32px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.ov-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.ov-table thead th {
  padding: 8px 14px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #f1f5f9;
}

.ov-table tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  color: #334155;
}

.ov-table tbody tr:last-child td {
  border-bottom: none;
}

.ov-org-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
}

.ov-org-email {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 1px;
}

.ov-days {
  font-weight: 600;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.ov-days--warn {
  color: #d97706;
}

.ov-days--urgent {
  color: #dc2626;
}

.ov-empty {
  padding: 28px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.ov-page-loading,
.ov-page-error {
  padding: 48px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.ov-page-error h3 {
  color: #334155;
  font-size: 16px;
  margin: 0 0 6px;
}

.ov-retry {
  margin-top: 12px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: #2563eb;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.animate-spin {
  animation: ov-spin 0.8s linear infinite;
}

@keyframes ov-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 1100px) {
  .ov-stats {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 640px) {
  .ov-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OverviewPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yEAAyE;EACzE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAO;AACT;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".ov-page {\n  min-height: 100%;\n}\n\n.license-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n}\n\n.ov-page--embedded {\n  min-height: 0;\n}\n\n.ov-page--embedded .ov-stats {\n  margin-bottom: 0;\n}\n\n.ov-stats--loading .ov-stat--skeleton {\n  min-height: 88px;\n  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);\n  background-size: 200% 100%;\n  animation: ov-shimmer 1.2s infinite;\n}\n\n@keyframes ov-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.ov-page-error-inline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  margin-bottom: 8px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  color: #991b1b;\n  font-size: 14px;\n}\n\n.ov-page-error-inline p {\n  margin: 0;\n  flex: 1;\n}\n\n\n.ov-stats {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.ov-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 14px 14px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: left;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.ov-stat:not(.ov-stat--static) {\n  cursor: pointer;\n}\n\n.ov-stat:not(.ov-stat--static):hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.ov-stat--active {\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);\n}\n\n.ov-stat-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.ov-stat-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ov-stat-icon--blue { background: #eff6ff; color: #2563eb; }\n.ov-stat-icon--green { background: #ecfdf5; color: #059669; }\n.ov-stat-icon--amber { background: #fffbeb; color: #d97706; }\n.ov-stat-icon--red { background: #fef2f2; color: #dc2626; }\n.ov-stat-icon--slate { background: #f1f5f9; color: #64748b; }\n\n.ov-stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.1;\n  font-variant-numeric: tabular-nums;\n}\n\n.ov-stat-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ov-stat-hint {\n  font-size: 14px;\n  color: #cbd5e1;\n  margin-top: -2px;\n}\n\n.ov-stat--clickable .ov-stat-hint {\n  color: #94a3b8;\n}\n\n/* Expiring panel */\n.ov-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  animation: ov-slide 0.18s ease-out;\n}\n\n@keyframes ov-slide {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.ov-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafbfc;\n}\n\n.ov-panel-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #334155;\n  margin: 0;\n}\n\n.ov-panel-sub {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 2px 0 0;\n}\n\n.ov-panel-close {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ov-panel-body {\n  position: relative;\n  min-height: 60px;\n}\n\n.ov-panel-loading {\n  padding: 32px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.ov-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.ov-table thead th {\n  padding: 8px 14px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.ov-table tbody td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n  color: #334155;\n}\n\n.ov-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.ov-org-name {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.ov-org-email {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 1px;\n}\n\n.ov-days {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.ov-days--warn {\n  color: #d97706;\n}\n\n.ov-days--urgent {\n  color: #dc2626;\n}\n\n.ov-empty {\n  padding: 28px 16px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.ov-page-loading,\n.ov-page-error {\n  padding: 48px 16px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.ov-page-error h3 {\n  color: #334155;\n  font-size: 16px;\n  margin: 0 0 6px;\n}\n\n.ov-retry {\n  margin-top: 12px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 8px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.animate-spin {\n  animation: ov-spin 0.8s linear infinite;\n}\n\n@keyframes ov-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 1100px) {\n  .ov-stats {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .ov-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
